import { useState } from "react";

export const SkillSection = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="skill-section">
      <button className="skill-section-header" onClick={() => setOpen(!open)}>
        <h4>{title}</h4>
        <span className={`arrow ${open ? "open" : ""}`}>▾</span>
      </button>

      <div className={`skill-section-content ${open ? "open" : ""}`}>
        {children}
      </div>
    </div>
  );
};